import Vue from "vue";
import Component from "vue-class-component";
import MapService from "@/api/Services/MapService";
import ServiceDefaultName from "@/api/Services/ServiceDefaultName";
import router from "@/router";
import SelectServiceDefaultNames from "@/components/Util/SelectServiceDefaultNames/SelectServiceDefaultNames.vue";

import { busHome } from "@/views/Home/HomeBus";
import { AddressInterface } from "@/api/Interfaces/MapInterface";
import { GeoCoordinatesInterface } from "@/api/Interfaces/MapInterface";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import * as LogoClinicarx from "@/assets/images/Logo_nova.png";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";

const LocationCardProps = Vue.extend({
  props: {
    tenancyId: {
      type: String,
      required: false,
    },

    headerLogo: {
      type: String || LogoClinicarx,
    },

    iframeMode: {
      type: Boolean,
      default: false,
    },
  },
});
@Component<LocationCardComponent>({
  name: "LocationCardComponent",

  components: {
    "select-service-default-names": SelectServiceDefaultNames,
  },

  computed: {
    canSearchServices: function () {
      return !!this.cx_selectedServiceDefaultName && !!this.cx_coordinates && !this.cx_isInvalidCep;
    },
    cx_zipCodeSearchCheck: {
      get(): boolean {
        return this.$store.state.globalSearch.getZipCodeSearchCheck;
      },
      set(value: boolean): void {
        if (value) {
          this.cx_zipCodeIsVisible = true;
          this.cx_isConsultingGeoCoordinatesCheckBox = false;
          this.cx_checkboxZipCodeIsActive = "text_checkbox_active";
        } else {
          this.cx_zipCodeIsVisible = false;
          this.cx_checkboxZipCodeIsActive = "";
        }

        this.$store.commit("setZipCodeSearchCheck", value);
      },
    },
  },

  watch: {
    cx_isConsultingGeoCoordinatesCheckBox(newValue: boolean) {
      if (newValue && this.cx_iframeMode) this.confirmMyLocation();
      else if (newValue && !this.cx_allowAccessMyLocation) this.openConfirmMyLocationModal();
      else this.cx_allowAccessMyLocation = false;
    },

    cx_zipCode(newValue: string) {
      if (newValue.length == 8) this.consultZipCode();
    },

    cx_allowAccessMyLocation(newValue: boolean) {
      if (newValue) this.activateMyLocation();
    },
  },
})
export default class LocationCardComponent extends LocationCardProps {
  cx_zipCode!: string;
  cx_zipCodeCheckBox!: boolean;
  cx_zipCodeIsVisible!: boolean;
  cx_isConsultingZipCode!: boolean;
  cx_isInvalidCep!: boolean;
  cx_checkboxZipCodeIsActive!: string;
  cx_directSearch!: boolean;
  cx_header_logo: any;
  cx_iframeMode: any;

  cx_isConsultingGeoCoordinates!: boolean;
  cx_isConsultingGeoCoordinatesCheckBox!: boolean;
  cx_allowAccessMyLocation!: boolean;

  cx_address!: string;

  cx_selectedServiceDefaultName!: any;
  cx_ServiceDefaultName!: ServiceDefaultName;
  cx_serviceCategories!: Array<ServiceDefaultName>;
  cx_buttonActive!: string;
  cx_coordinates!: GeoCoordinatesInterface;

  constructor() {
    super();

    this.cx_zipCode = "";
    this.cx_zipCodeCheckBox = false;
    this.cx_zipCodeIsVisible = false;
    this.cx_isConsultingZipCode = false;
    this.cx_isInvalidCep = false;
    this.cx_checkboxZipCodeIsActive = "";

    this.cx_isConsultingGeoCoordinates = false;
    this.cx_isConsultingGeoCoordinatesCheckBox = false;
    this.cx_allowAccessMyLocation = false;
    this.cx_directSearch = false;

    this.cx_address = "";

    this.cx_ServiceDefaultName = new ServiceDefaultName();
    this.cx_selectedServiceDefaultName = null;
    this.cx_serviceCategories = [] as Array<ServiceDefaultName>;
    this.cx_coordinates = {} as GeolocationCoordinates;
    this.cx_buttonActive = "";
    this.cx_header_logo = this.headerLogo || LogoClinicarx;
    this.cx_iframeMode = this.iframeMode;
  }

  mounted() {
    this.cx_zipCode = "";
    this.cx_zipCodeCheckBox = false;
    this.cx_zipCodeIsVisible = false;
    this.cx_isConsultingZipCode = false;
    this.cx_isInvalidCep = false;
    this.cx_checkboxZipCodeIsActive = "";

    this.cx_isConsultingGeoCoordinates = false;
    this.cx_isConsultingGeoCoordinatesCheckBox = false;
    this.cx_allowAccessMyLocation = false;

    this.cx_address = "";
    this.cx_serviceCategories = [] as Array<ServiceDefaultName>;
    this.cx_coordinates = {} as GeolocationCoordinates;
    this.cx_buttonActive = "";
    this.cx_selectedServiceDefaultName = null;

    busHome.$on("searchServiceDefaultNameByCode", this.searchServiceDefaultNameByCode);

    this.searchServiceDefaultNames();
    this.getNavigatorGeolocationState();
  }

  consultZipCode(): void {
    this.cx_isConsultingZipCode = true;

    MapService.getLocationByZipCode(this.cx_zipCode)
      .then((response) => {
        const address: AddressInterface = response as AddressInterface;
        if (address) {
          this.cx_isInvalidCep = false;
          this.setAddress(address);

          MapService.getGeoCoordinatesByAddress(address).then((response) => {
            this.cx_coordinates = response as GeoCoordinatesInterface;
          });
        } else {
          this.cx_isInvalidCep = true;
          this.cx_coordinates = {} as GeoCoordinatesInterface;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => (this.cx_isConsultingZipCode = false));
  }

  activateMyLocation(): void {
    if (!navigator.geolocation) {
      alert("O seu navegador não suporta Geolocalização");
      return;
    }

    this.cx_isConsultingGeoCoordinates = true;

    navigator.geolocation.getCurrentPosition(
      (response) => {
        this.cx_coordinates = {} as GeoCoordinatesInterface;
        this.cx_coordinates.latitude = response.coords.latitude;
        this.cx_coordinates.longitude = response.coords.longitude;

        MapService.getAddressByGeoCoordinates(response.coords.latitude, response.coords.longitude)
          .then((response) => {
            const address: AddressInterface = response as AddressInterface;
            if (address) {
              this.setAddress(address);

              if (this.cx_directSearch) {
                this.goToSearch();
              }
            } else {
              throw new Error(address);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.cx_isConsultingGeoCoordinates = false));
      },

      (error) => {
        this.cx_isConsultingGeoCoordinates = false;
      }, 

      { enableHighAccuracy: true }
    );
  }

  getNavigatorGeolocationState(): void {
    if (navigator.permissions && typeof navigator.permissions.query == "function") {
      //try permissions APIs first
      navigator.permissions.query({ name: "geolocation" }).then((response) => {
        this.cx_allowAccessMyLocation = response["state"] == "granted";
        response.onchange = () => {
          if (this.cx_address == "") {
            this.cx_allowAccessMyLocation = response["state"] == "granted";
            this.activateMyLocation();
          }
        };
      });
    } else if (navigator.geolocation) {
      this.cx_allowAccessMyLocation = true;
    }
  }

  openConfirmMyLocationModal(): void {
    this.$bvModal.show("confirm-my-location-modal");
  }

  closeConfirmMyLocationModal(allowAccess: boolean): void {
    this.$bvModal.hide("confirm-my-location-modal");

    if (allowAccess) {
      this.cx_allowAccessMyLocation = true;
      GoogleAnalyticsEvents.allowLocation();
    } else {
      this.cx_isConsultingGeoCoordinatesCheckBox = false;
      GoogleAnalyticsEvents.dontAllowLocation();
      if (this.cx_directSearch) {
        this.cx_directSearch = false;
        this.cx_selectedServiceDefaultName = null;
      }
    }
  }

  confirmMyLocation(): void {
    this.closeConfirmMyLocationModal(true);
  }

  searchServiceDefaultNames(): void {
    ServiceDefaultName.listWithAverage(this.tenancyId)
      .then((response) => {
        const responseData = response.data as ResponseInterface;
        responseData.data.length
          ? (this.cx_buttonActive = "btn_isActive")
          : (this.cx_buttonActive = "");
        this.cx_serviceCategories = response.data.data;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  changeServiceDefaultName(serviceDefaultName: ServiceDefaultNameInterface): void {
    this.cx_selectedServiceDefaultName = serviceDefaultName;
    window.sessionStorage.setItem("service", JSON.stringify(this.cx_selectedServiceDefaultName));
  }

  setAddress(address: AddressInterface): void {
    this.cx_address = address.street
      ? `${address.street}, ${address.city}/${address.state}`
      : `${address.city}/${address.state}`;
    window.sessionStorage.setItem("address", this.cx_address);
  }

  setErrorPage(): void {
    if (this.$route.name !== "SearchError") this.$router.push({ name: "SearchError" });
  }

  goToSearch(): void {
    const viewParams: any = {
      serviceName: this.cx_selectedServiceDefaultName.url_parameter,
      selectedServiceDefaultName: this.cx_selectedServiceDefaultName,
      address: this.cx_address,
      coordinates: this.cx_coordinates,
      zipCode: this.cx_zipCode,
      tenancyId: this.tenancyId,
      headerLogo: this.cx_header_logo,
    };
    window.sessionStorage.setItem("coordinates", JSON.stringify(this.cx_coordinates));
    window.sessionStorage.setItem("zipcode", JSON.stringify(this.cx_zipCode));

    if (this.cx_iframeMode) {
      const routeData = router.resolve({
        name: "SearchServices",
        params: viewParams,
      });
      window.open(routeData.href, "_blank");
    } else if (this.tenancyId != "") {
      router.push({ name: "SearchServicesTenancy", params: viewParams });
    } else {
      router.push({
        name: "SearchServices",
        params: viewParams,
      });
    }
  }

  searchServiceDefaultNameByCode(code: string): void {
    this.cx_selectedServiceDefaultName = this.cx_serviceCategories.find((el: any) => {
      return el.code == code;
    });
    const strDebug = `${this.cx_selectedServiceDefaultName.code} | ${this.cx_zipCode} | ${this.cx_coordinates.latitude}`;
    if (!this.cx_coordinates.latitude && (!this.cx_zipCode || this.cx_isInvalidCep)) {
      this.cx_directSearch = true;
      this.openConfirmMyLocationModal();
    } else {
      this.cx_directSearch = false;
      this.goToSearch();
    }
  }

  canSearch(): boolean {
    const isValidCoordinates = this.cx_zipCodeIsVisible
      ? this.cx_zipCode.length == 8 && !this.cx_isInvalidCep
      : this.cx_coordinates.latitude;
    return this.cx_selectedServiceDefaultName && isValidCoordinates;
  }

  formatCurrency(str: string): string {
    return parseFloat(str).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
}
